import React from "react";
import { useDispatch } from "react-redux";
import CreateNewWallPopup from "../../../Walls/Component/modal/CreateNewWallPopup";
import { openCreateNewWallPopup } from "../../../../../../actions/wallsAction";
import { closePricingModal } from "../../../../../../utils/close_modal";
import { togglePlanSection_D } from "../../../../../../actions/showDisplayModalAction";
import UpgradePopUp from "../../../Walls/Component/UpgradePopUp";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";
import { Button } from "react-bootstrap";

const CreateWall = (props) => {
  const { firstWall, isCollaboratorRole, clickToUpdateState, modalData, upgrade, setUpgrade, setupdateWall, setModalData, widgetWallsData } = props;

  const dispatch = useDispatch();

  const clickToHideUpgrade = (event) => {
    setUpgrade(false);
    dispatch(openCreateNewWallPopup(false));
    closePricingModal(dispatch);
  };

  const onClickUpgrade = (event) => {
    setUpgrade(false);
    dispatch(togglePlanSection_D(true));
  };

  return (
    !isCollaboratorRole ? (
      <>
        <div className="">
          {firstWall ?
            <>
              <div onClick={clickToUpdateState({ modalShow: true, wall_id: null, autoUpdate: 1, })} className="add_wall_icon">
                <span className="svg-icon f-center bg-light rounded-circle w-100 h-100"><FontAwesomeIcon type={'regular'} icon={'plus'} iconClass={'fs-2'} />{" "} </span>
              </div>
              <h5 className="text-center mt-3 mb-0"><span className="add_wall_card_txt popUp hide-on-desktop createWallbtn">Create Wall</span></h5>
            </>
            :
            <Button variant="secondary" onClick={clickToUpdateState({ modalShow: true, wall_id: null, autoUpdate: 1, })} className="d-flex px-3 border-0">
              <span className="position-relative">
                <FontAwesomeIcon type={'solid'} icon={'plus'} iconClass={'fs-6 text-secondary me-1'} /> {" "} {widgetWallsData && Object.keys(widgetWallsData).length ? "Create New Wall" : "Create Wall"}{" "} 
              </span>
            </Button>
          }
        </div>
        <CreateNewWallPopup setupdateWall={setupdateWall} show={modalData.modalShow} onHide={() => { setModalData({ modalShow: false }); dispatch(openCreateNewWallPopup(false)); }} {...modalData} />
        <UpgradePopUp show={upgrade} onHide={clickToHideUpgrade} {...modalData} onClickUpgrade={onClickUpgrade} />
        {" "}
      </>)
      : null)
};

export default React.memo(CreateWall);
